// Sort a collection of elements that can be integers, floats and strings
// elements that can parse to floats will be ordered first, followed by strings
// Takes a collection (array of elements) and an optional accessor function to access the property of the element to be sorted on
//   example: mixedSort(collection, (o) => o.filter_values[uuid].sort_value )
export const mixedSort = <A>(
  collection: Array<A>,
  accessor = <O>(o: O): O => o,
  priorityFn = <O>(_o: O): boolean => false
): Array<A> => {
  // First compare as floats, then as strings.
  return collection.sort((a, b) => {
    if (priorityFn) {
      if (priorityFn(a)) {
        return -1
      }

      if (priorityFn(b)) {
        return 1
      }
    }

    // If we want to make this re-usable we should de-couple the next 2 lines
    const sortValueA = accessor(a)
    const sortValueB = accessor(b)

    const aIsNullish =
      sortValueA === null || sortValueA === undefined || sortValueA === ''
    const bIsNullish =
      sortValueB === null || sortValueB === undefined || sortValueB === ''

    if (aIsNullish && !bIsNullish) {
      return -1
    }
    if (!aIsNullish && bIsNullish) {
      return 1
    }
    if (aIsNullish && bIsNullish) {
      return 0
    }

    const floatA = typeof sortValueA === 'string' ? parseFloat(sortValueA) : NaN
    const floatB = typeof sortValueB === 'string' ? parseFloat(sortValueB) : NaN
    // Both parse as numbers, and are different
    if (floatA && floatB && floatA !== floatB) {
      return floatA - floatB
    }
    // A parses as float, but B doesn't
    if (floatA && isNaN(floatB)) {
      return -1
    }
    // B parses as float, but A doesn't
    if (isNaN(floatA) && floatB) {
      return 1
    }
    // String comparison
    if (sortValueA < sortValueB) {
      return -1
    }
    if (sortValueA > sortValueB) {
      return 1
    }
    return 0
  })
}
